// -- AUTOGENERATED --

// eslint-disable-next-line no-unused-vars
import APIUtils from '@/util/apiutil'

import Axios from 'axios'
import NETVSConfig from '@/../netvs.config'

/* eslint-disable camelcase */
/* eslint-disable quote-props */
/* eslint-disable object-curly-spacing */
/* eslint-disable array-bracket-spacing */
/* eslint-disable object-shorthand */
export default {

  bulk_updateParamsList () {
    return {'old': [ 'cidr'], 'new': [ 'cidr']}
  },
  bulk_update (config, {cidr_old, cidr_new}) {
    const params = { 'new': { 'cidr': cidr_new}, 'old': { 'cidr': cidr_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/ip_addr/bulk_update`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  createParamsList () {
    return {'old': [ ], 'new': [ 'value', 'is_dhcp', 'is_reserved']}
  },
  create (config, {value_new, is_dhcp_new = false, is_reserved_new = false}) {
    const params = { 'new': { 'value': value_new, 'is_dhcp': is_dhcp_new, 'is_reserved': is_reserved_new}, 'old': { }}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/ip_addr/create`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  deleteParamsList () {
    return {'old': [ 'value'], 'new': [ ]}
  },
  delete (config, {value_old}) {
    const params = { 'new': { }, 'old': { 'value': value_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/ip_addr/delete`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  list (config, { cidr, type, is_own, is_dhcp, gpk_list, value_list, fetch_limit, is_reserved, fetch_offset, is_rr_target, filter_params_dict, sorting_params_list }) {
    const params = APIUtils.denullify_dict({ 'cidr': cidr, 'type': type, 'is_own': is_own, 'is_dhcp': is_dhcp, 'gpk_list': (gpk_list === null) ? null : JSON.stringify(gpk_list), 'value_list': (value_list === null) ? null : JSON.stringify(value_list), 'fetch_limit': fetch_limit, 'is_reserved': is_reserved, 'fetch_offset': fetch_offset, 'is_rr_target': is_rr_target, 'filter_params_dict': filter_params_dict, 'sorting_params_list': (sorting_params_list === null) ? null : JSON.stringify(sorting_params_list)})
    const cnf = {}
    Object.assign(cnf, (config || {}).netdb_axios_config)
    cnf.params = params
    return Axios.get(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/ip_addr/list`, cnf)
  // eslint-disable-next-line comma-dangle
  },
  updateParamsList () {
    return {'old': [ 'value'], 'new': [ 'is_dhcp', 'is_reserved']}
  },
  update (config, {value_old, is_dhcp_new, is_reserved_new}) {
    const params = { 'new': { 'is_dhcp': is_dhcp_new, 'is_reserved': is_reserved_new}, 'old': { 'value': value_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/dns/ip_addr/update`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
}
